import Hotjar from "@hotjar/browser";

const siteId = 5111364;
const hotjarVersion = 6;

export function loadHotjar() {
    Hotjar.init(siteId, hotjarVersion);
}
